<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p>It isn’t often in the world of fiction that we are given insights into the forces that shape the lives and personalities of the adolescent male. It is one of the most under-researched issues in human development. Boys have always been under pressure—from parents, particularly fathers—who so often feel a compulsion to impose the same harsh physical and mental strictures on their sons that they grew up with. Emotions are suppressed. Feelings, not least those about his own place in a family or school or, ultimately, in the wider society in which he must live, are often subject to forces he can’t understand. It is exceptionally hard for a boy to find his way toward self-assurance and many grow up with an acute confidence problem. That problem is all too evident in the personal despair and sometimes suicidal responses of so many teenagers who can see no other prospects ahead of them.</p>
<p>This book is an exploration of that awful dilemma. It is also a celebration of personal achievement by one boy through the medium of rugby. In ‘Kicking Goals’ Shirley Deuchrass has skilfully reimagined a family story that ends in self-realisation for a brother who has suffered under the weight of under-achievement, the austere regimes of farm and school life, where the twin evils of repression and bullying reign supreme. The prospect emerging from this is one of never being really good at anything. It is a syndrome that many readers will easily recognise and it persists to this day. ‘Kicking Goals’ is a universal story and yet it is a deeply personal and local one, full of the details and foibles of family and school life. It shows, above all, that self-belief can be attained in unusual ways and that when confidence comes, it can be a revelation.</p>
<br/>
<p style="text-indent:00em;">Chris Laidlaw</p>
<p style="text-indent:00em;">New Zealand Broadcaster, columnist, author, Regional Councillor, sports commentator and former Rhodes Scholar, Ambassador All Black and MP</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6914f621